import { SIGNUP_STEPS } from '../../../types/enum';
import { isString } from '../../../lib/validation';
import { GENDER } from '../../../types/enum';
import TextSelect from '../../../components/textSelect';
import DateInput from '../../../components/dateInput';

const GenderBirth = ({
  gender,
  setGender,
  birth,
  setBirth,
  setCurrentStep,
}) => {
  const handleInput = (key) => (e) => {
    const value = String(e.target.value);
    if (key === 'birth') {
      setBirth(value);
    }
    if (key === 'gender') {
      setGender(value);
    }
  };

  const handleNext = () => {
    try {
      setCurrentStep(SIGNUP_STEPS.HEIGHT_WEIGHT);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <h1 className='font-bold mb-1 text-white text-4xl'>
        What's your gender and birthday?
      </h1>
      <p className='mb-3 text-xs italic text-white'>
        This information is required to accurately calculate BMI and BMR.
      </p>
      <div className='mb-5 space-y-2'>
        <select
          className='w-full bg-white rounded-full py-3 px-4 '
          onChange={handleInput('gender')}
          value={gender ?? ''}
        >
          <option
            value=''
            disabled
          >
            Select Gender
          </option>
          <option value={GENDER.MALE}>Male</option>
          <option value={GENDER.FEMALE}>Female</option>
          <option value={GENDER.NOT_SPECIFIED}>Not Specified</option>
        </select>
        <input
          type='date'
          className='w-full bg-white rounded-full py-2 px-4 '
          onChange={handleInput('birth')}
          value={birth}
        />
      </div>
      <button
        className={`w-full bg-yellow-500 text-black font-bold rounded-full hover:bg-yellow-600 transition-colors duration-200 py-3 ${
          !gender || !birth
            ? 'opacity-40'
            : 'hover:bg-yellow-600 transition-colors duration-200'
        }`}
        onClick={handleNext}
        disabled={!gender || !birth}
      >
        Next
      </button>
    </div>
  );
};

export default GenderBirth;
